function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "car_1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "car_1"
}, /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 2.43,
  y1: 33.45,
  x2: 7.03,
  y2: 33.45
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-1",
  cx: 48.03,
  cy: 41.64,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-1",
  cx: 13.89,
  cy: 41.64,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 17.97,
  y1: 41.64,
  x2: 43.94,
  y2: 41.64
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M52.11,41.64h5.73A2.82,2.82,0,0,0,60.79,39V29.92a3.51,3.51,0,0,0-1-2.42l-8.46-8a3.12,3.12,0,0,0-2.28-1H27.51a3.63,3.63,0,0,0-2.87,1.41L18,28.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M44.83,18.51,50,27.26a.78.78,0,0,1-.57,1.31l-34.89,0H5.82a3.4,3.4,0,0,0-3.39,3.4v7c0,1.47,1.47,2.66,3.28,2.66H9.8"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 32.61,
  y1: 18.53,
  x2: 32.61,
  y2: 28.56
}));

var SvgCar1 = function SvgCar1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car_1.afe9e837.svg";
export { ForwardRef as ReactComponent };